import React from 'react';
import { Link } from 'react-router-dom';
import { search, filter } from '../../assets';

interface SearchActionsProps {
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFilterClick: () => void;
  onExportClick: () => void;
  onStartSaleClick: () => void;
}

const SearchActions: React.FC<SearchActionsProps> = ({
  onSearchChange,
  onFilterClick,
  onExportClick,
  onStartSaleClick,
}) => {
  return (
    <nav className="flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-3 sm:gap-4 mt-4 py-2 bg-white w-full">
      {/* Search field - full width on mobile */}
      <div className="flex items-center gap-2 px-2 py-2.5 w-full sm:w-[280px] text-sm leading-none border rounded-md shadow-sm">
        <img
          loading="lazy"
          src={search}
          alt=""
          className="w-4 h-4 object-contain"
        />
        <input
          type="text"
          placeholder="Search for a sale"
          className="flex-1 text-slate-400 bg-transparent border-none outline-none placeholder-opacity-50"
          onChange={onSearchChange}
          aria-label="Search for a sale"
        />
      </div>

      {/* Action buttons - wrapped in a flex container */}
      <div className="flex flex-wrap gap-2 sm:gap-4 justify-between sm:justify-end w-full sm:w-auto">
        <button
          className="flex justify-center items-center p-2 bg-white border rounded-md text-sm"
          onClick={onFilterClick}
        >
          <img
            loading="lazy"
            src={filter}
            alt="Filter"
            className="w-4 h-4 object-contain mr-2"
          />
          Filter
        </button>

        <button 
          className="btn-action p-2 sm:p-3 text-sm flex-1 sm:flex-none text-center" 
          onClick={onExportClick}
        >
          Export.CVS
        </button>

        <Link to="/sales/create-fund" className="flex-1 sm:flex-none">
          <button 
            className="btn-primary w-full" 
            onClick={onStartSaleClick}
          >
            Start a sale
          </button>
        </Link>
      </div>
    </nav>
  );
};

export default SearchActions;
